// extracted by mini-css-extract-plugin
module.exports = {"table":"Surveys_table__288gk"};